module.exports = __webpack_public_path__ + "img/ss.d6ebcf80.jpg";